import React from "react";
import "../assets/css/MiCurso.css";
import { Link } from "react-router-dom";
import { useContext } from "react";
import Contexto from "../context/Contexto";
import { useEffect, useState } from "react";
import Play from "../assets/CCstatics/play.png";
import EnviarReto from "./EnviarReto";
const MiCurso = (props) => {
  const { Griseado, bajarCertificado, cliente } = useContext(Contexto);
  const { curso, restantes, info, nombre, totales, examen, escuela, color } =
    props;
  let { esPrograma } = info;
  const [examenAprobado, setExamenAprobado] = useState(false);
  const [totalProgreso, setTotalProgreso] = useState(0);
  const [retou, setRetou] = useState(false);

  useEffect(() => {
    if (examen && examen.hasOwnProperty(curso)) {
      setExamenAprobado(examen[curso].aprobado);
    }
    if (totales && totales.hasOwnProperty(curso)) {
      if (totales[curso]) {
        setTotalProgreso(totales[curso].total);
      }
    }
    if (cliente.hasOwnProperty("retosDS")) {
      if (cliente.retosDS.retos[0].url) {
        setRetou(true);
      }
    }
  }, []);

  return (
    <>
      <div
        className={"item-curso"}
        style={{ background: color != "" ? "#fe50ff" : color }}
      >
        <p className="otra">{info.nombre}</p>
        {restantes < 0 ? (
          <p>No te quedan días :(</p>
        ) : (
          <>
            {escuela == "" && (
              <p className="blanco"> {`Te quedan ${restantes} días`}</p>
            )}
            {!escuela && <p className="white">Te quedan {restantes} días</p>}

            <div
              className="blanco cursor"
              onClick={() => {
                if (escuela) {
                  Griseado(`ver/color-club/${escuela}/${curso}`);
                } else {
                  Griseado(`ver/${curso}`);
                }
              }}
            >
              VER CURSO
            </div>
            <img
              src={Play}
              alt=""
              className="playloco"
              onClick={() => {
                if (escuela) {
                  Griseado(`ver/color-club/${escuela}/${curso}`);
                } else {
                  Griseado(`ver/${curso}`);
                }
              }}
            />

            <EnviarReto programa={info.url.substr(1)}></EnviarReto>
          </>
        )}

        {totalProgreso > 99 && <></>}

        <>
          <progress
            value={totalProgreso}
            max="100"
            id="progreso"
            className="progres"
          ></progress>
          Ya viste el {totalProgreso.toFixed(2)}%
        </>
        {/*  */}
        {totalProgreso.toFixed(2) > 99 && retou && (
          <div
            className="blanco cursor"
            onClick={() => {
              Griseado(`examenes/designseason`);
            }}
          >
            RENDIR EXAMEN
          </div>
        )}
      </div>
    </>
  );
};

export default MiCurso;
